import React from 'react';
import Layout from '../Layout';
import './index.less';
import {Message} from 'tinper-bee';
import * as util from '../../utils';

class Basic extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    async componentDidMount() {
        const result: any = await util.get('/user/info');
        this.setState({user: result.data})
    }

    render() {
        const {user = {}} = this.state
        return (
            <React.Fragment>
                <div className='basic-top'>
                    <div className='avatar'>
                        <img src={user.avatar}/>
                    </div>
                    <div  className='name'>
                        <p>
                            姓名：
                        </p>
                        <span>{user.name}</span>
                    </div>
                </div>
                <div className='info'>
                    <div className='basic-bottom-left'>
                        登录方式
                    </div>
                    <div  className='basic-bottom-right'>
                        {
                            user.email ?
                                <p>
                                    邮箱：{user.email}
                                </p> :null
                        }
                        {
                            user.phone ?
                                <p>
                                    手机号：{user.phone}
                                </p> :null
                        }
                        {
                            user.other ?
                                <p>
                                    其他登录方式：{user.other}
                                </p> :null
                        }
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default Basic;
